import TabContainer from '../tabs/tabContainer';

export default class InkTonerSwitcher extends TabContainer {
	constructor(tabsContainer) {
		super(tabsContainer);
		if (!tabsContainer) return;
		this.switchIfAssistedSearch();
	}

	switchIfAssistedSearch() {
		if (this.getSectionType() === 'cartridge') {
			super.selectedTab = 'inkTonerFreeTextSearchContent';
			super.switchTabs();
		}
	}

	getSectionType() {
		return window.location.href
			.substr(window.location.href.lastIndexOf('/') + 1)
			.split('?')[0];
	}
}
